import type {DibJsonNode, RenderableDocument} from "./types";

/**
 * Resolves an element id to the node render rules see: the element, its
 * object (a pointer-x-var followed to its variable) and the kind rules
 * discriminate on. Shared by the render engine and the docgen data check.
 * dokumentgenerator's rules depend on exactly this resolution: read
 * docgen/CLAUDE.md before changing it.
 */
export const getNode = (topicData: RenderableDocument, id: string): DibJsonNode => {
    const element = topicData.elements[id] || null;

    // Reference the real object if object.type === "pointer-x-var"
    let obj = topicData.objects?.[id] || null;
    if (obj?.type === "pointer-x-var") {
        obj = topicData.objects?.[obj.data.varId] || null;
    }

    const elementData = topicData.elementdata?.[id] || null;

    // 1. Determine "kind"
    const imgKind = topicData.elements?.[id]?.name === "img" ? "image" : null;
    // 1.1 Slightly hacky, but there is a mismatch between the element.attributes.class
    //     and object.data.type in some cases. If the object has the endPoint property,
    //     it is coming from legacy resource data, so we can ignore it
    const objectKind =
        obj?.type === "linkdata" && !("endPoint" in obj.data)
            ? obj.data.type
            : null;

    const kind =
        imgKind || objectKind || element?.attributes?.class || obj?.type;

    return {kind, element, object: obj, elementData};
};
